// extracted by mini-css-extract-plugin
export default {"sidemenu":"sideMenu_sidemenu__crMQt"};